const LOAD_DATA_MASTER_EDUCATION_LEVEL           = 'LOAD_DATA_MASTER_EDUCATION_LEVEL'
const LOAD_DATA_MASTER_EDUCATION_LEVEL_SUCCESS   = 'LOAD_DATA_MASTER_EDUCATION_LEVEL_SUCCESS'
const LOAD_DATA_MASTER_EDUCATION_LEVEL_FAILED    = 'LOAD_DATA_MASTER_EDUCATION_LEVEL_FAILED'
const UNMOUNT_DATA_MASTER_EDUCATION_LEVEL        = 'UNMOUNT_DATA_MASTER_EDUCATION_LEVEL'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const masterEducationLevelReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DATA_MASTER_EDUCATION_LEVEL:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DATA_MASTER_EDUCATION_LEVEL_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DATA_MASTER_EDUCATION_LEVEL_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DATA_MASTER_EDUCATION_LEVEL:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default masterEducationLevelReducer;